module.exports = __webpack_public_path__ + "static/flowers-34f429ad4c45b8f5cd8a5ca3a9200ff0.gif";